{
  "scheduling": "预约排班",
  "date": "日期",
  "time": "时间",
  "duration": "时长",
  "provider": "医生",
  "reason": "就诊原因",
  "status": "状态",
  "statusOptions": {
    "scheduled": "已预约",
    "confirmed": "已确认",
    "arrived": "已到达",
    "checked-in": "已签到",
    "in-progress": "进行中",
    "completed": "已完成",
    "cancelled": "已取消",
    "no-show": "爽约"
  },
  "coverageScope": {
    "panel": "患者组",
    "unit": "病区",
    "facility": "整个机构"
  },
  "coverageScopeDescription": {
    "panel": "仅限被代班医生的患者组。",
    "unit": "被代班医生所属的病区。",
    "facility": "整个机构 — 通常为值班安排。"
  },
  "dayShort": {
    "0": "日",
    "1": "一",
    "2": "二",
    "3": "三",
    "4": "四",
    "5": "五",
    "6": "六"
  },
  "blockType": {
    "available": "可预约",
    "blocked": "已封锁"
  },
  "appointmentTypes": {
    "followUp": "复诊",
    "newPatient": "新患",
    "consultation": "咨询",
    "procedure": "操作",
    "urgent": "急诊",
    "wellnessCheck": "健康检查",
    "physical": "体检",
    "telemedicine": "远程医疗",
    "scheduleTemplate": "排班模板"
  },
  "pages": {
    "providerDirectory": {
      "title": "医生目录",
      "subtitle": "浏览并搜索医疗服务提供者",
      "search": {
        "namePlaceholder": "按姓名搜索...",
        "specialtyPlaceholder": "按专科搜索..."
      },
      "filters": {
        "facilityAriaLabel": "按机构筛选",
        "departmentAriaLabel": "按科室筛选",
        "allFacilities": "全部机构",
        "allDepartments": "全部科室"
      },
      "loading": "正在加载医生信息...",
      "loadError": "无法加载医生目录。",
      "empty": "未找到符合条件的医生。",
      "npiLabel": "NPI:"
    },
    "scheduleTemplateForm": {
      "title": "创建排班模板",
      "labels": {
        "provider": "医生",
        "dayOfWeek": "星期",
        "startTime": "开始时间",
        "endTime": "结束时间",
        "slotDuration": "时段长度(分钟)",
        "templateName": "模板名称",
        "effectiveStartDate": "生效日期"
      },
      "slotDurationOption": "{{minutes}} 分钟",
      "buttons": {
        "cancel": "取消",
        "save": "保存模板"
      },
      "toast": {
        "success": "排班模板已保存",
        "failure": "保存排班模板失败"
      },
      "placeholders": {
        "templateName": "例如 周一上午门诊"
      },
      "defaultName": "{{day}} 排班"
    },
    "scheduleManagement": {
      "title": "排班管理",
      "backToDashboard": "← 仪表板",
      "newTemplate": "新建模板",
      "today": "今天",
      "blockTooltip": "{{start}} - {{end}} ({{state}})",
      "slotsLabel": "{{minutes}} 分钟时段",
      "legend": {
        "booked": "已预约"
      },
      "upcomingAppointmentsHeading": "即将到来的预约 - {{providerName}}",
      "loadingAppointments": "正在加载预约...",
      "unknownPatient": "未知患者",
      "fallbackAppointmentType": "普通",
      "noUpcomingAppointments": "该医生没有即将到来的预约"
    },
    "providerCoverage": {
      "title": "医生代班",
      "subtitle": "限时代班 — 在指定时间段内将您的患者组移交给同事。区别于紧急临时访问;用于休假、值班轮换和计划性请假。",
      "actions": {
        "newCoverage": "新建代班",
        "cancel": "取消"
      },
      "form": {
        "title": "新建代班安排",
        "labels": {
          "coveredProviderId": "被代班医生",
          "coveringProviderId": "代班医生",
          "scope": "范围",
          "from": "起始",
          "until": "截止",
          "reason": "原因"
        },
        "placeholders": {
          "coveredProviderId": "其患者组被代班的医生",
          "coveringProviderId": "在此期间接管的医生",
          "reason": "例如:4 月 22–29 日年假;周末值班代班"
        },
        "help": {
          "coveredProviderId": "无 COVERAGE_ADMIN 权限时，必须是您本人。",
          "coveringProviderId": "按姓名搜索并选择 — 绝不会将代班授予手动输入的 ID。"
        },
        "aria": {
          "effectiveFromDate": "生效起始日期",
          "effectiveFromTime": "生效起始时间",
          "effectiveUntilDate": "生效截止日期",
          "effectiveUntilTime": "生效截止时间"
        },
        "buttons": {
          "cancel": "取消",
          "create": "创建代班"
        },
        "typeaheadEmpty": "未找到医生"
      },
      "sections": {
        "mine": {
          "title": "我的代班",
          "subtitle": "我作为代班医生或被代班医生的所有记录。",
          "empty": "暂无代班记录。"
        },
        "all": {
          "title": "全部代班",
          "subtitle": "组织内所有代班安排。管理员视图。",
          "empty": "处处无代班。要么是好消息,要么是筛选条件过时。"
        }
      },
      "list": {
        "coveringConnector": "代班",
        "groups": {
          "active": "进行中 ({{count}})",
          "planned": "计划 / 过往 ({{count}})",
          "revoked": "已撤销 ({{count}})"
        },
        "untilRevoked": "直至撤销",
        "revokedPrefix": "已撤销",
        "revokeTitle": "撤销"
      },
      "revokeDialog": {
        "title": "撤销代班?",
        "description": "{{coveringProviderName}} 将不再代班 {{coveredProviderName}}。记录将保留在审计日志中。",
        "confirm": "撤销",
        "reasonPlaceholder": "此次代班提前结束的原因（选填）"
      },
      "toast": {
        "created": "已创建代班",
        "revoked": "已撤销代班",
        "invalid": "代班无效 — 请检查医生和日期",
        "forbidden": "不允许为此医生创建代班",
        "createFailed": "创建代班失败",
        "revokeFailed": "撤销代班失败"
      }
    },
    "appointments": {
      "title": "预约",
      "subtitle": "安排和管理患者预约",
      "actions": {
        "refresh": "刷新",
        "schedule": "安排预约",
        "arriveTitle": "记录到达",
        "arriveAria": "记录 {{patientName}} 的到达",
        "checkInTitle": "签到",
        "checkInAria": "为 {{patientName}} 签到",
        "rescheduleTitle": "改期",
        "rescheduleAria": "为 {{patientName}} 改期",
        "cancelTitle": "取消",
        "cancelAria": "取消 {{patientName}} 的预约",
        "checkedInLabel": "已签到",
        "startVisitTitle": "开始就诊",
        "startVisitAria": "开始 {{patientName}} 的就诊"
      },
      "weekNav": {
        "previous": "上一周",
        "previousAria": "上一周",
        "next": "下一周",
        "nextAria": "下一周"
      },
      "calendar": {
        "gridAria": "每周预约日历",
        "timeColumn": "时间",
        "loading": "正在加载排班...",
        "cellAria": "{{dayLabel}} {{date}} {{time}}",
        "cellTitle": "{{patientName}} - {{appointmentType}} ({{status}})"
      },
      "upcoming": {
        "heading": "即将到来的预约",
        "empty": "本周没有预约",
        "durationMinutes": "{{minutes}} 分钟",
        "columns": {
          "dateTime": "日期 / 时间",
          "patient": "患者",
          "type": "类型",
          "provider": "医生",
          "duration": "时长",
          "status": "状态",
          "actions": "操作"
        }
      },
      "toast": {
        "cancelled": "预约已取消",
        "cancelFailed": "取消预约失败",
        "visitStarted": "已开始就诊",
        "startVisitFailed": "无法开始就诊",
        "arrivalRecorded": "已记录到达",
        "arrivalFailed": "无法记录到达"
      }
    },
    "appointmentForm": {
      "title": {
        "create": "新建预约",
        "edit": "重新安排预约"
      },
      "labels": {
        "patient": "患者",
        "appointmentType": "预约类型",
        "provider": "医生",
        "scheduledAt": "预约时间",
        "duration": "时长",
        "reason": "就诊原因"
      },
      "placeholders": {
        "patientSearch": "按姓名或病历号搜索患者...",
        "provider": "医生姓名",
        "reason": "简要就诊原因..."
      },
      "patientTypeahead": {
        "empty": "未找到患者"
      },
      "aria": {
        "appointmentDate": "预约日期",
        "appointmentTime": "预约时间"
      },
      "durationOption": "{{minutes}} 分钟",
      "buttons": {
        "cancel": "取消",
        "schedule": "安排预约",
        "update": "更新预约"
      },
      "toast": {
        "created": "预约创建成功",
        "updated": "预约已更新",
        "createFailed": "创建预约失败",
        "updateFailed": "更新预约失败"
      },
      "validation": {
        "patientRequired": "请选择一位患者",
        "appointmentTypeRequired": "预约类型为必填项",
        "scheduledAtRequired": "请填写日期和时间",
        "durationInvalid": "时长必须在 1 到 480 分钟之间",
        "providerRequired": "请选择一位医生"
      },
      "providerTypeahead": {
        "empty": "未找到医生"
      },
      "loadingEdit": "正在加载预约…",
      "loadEditError": "无法加载此预约。",
      "patientLocked": "改期时不能更换患者。"
    },
    "waitlist": {
      "title": "预约候补名单",
      "backToDashboard": "← 仪表板",
      "entryCount": "{{count}} 条记录",
      "searchPlaceholder": "搜索患者姓名、病历号或备注...",
      "clearSearchAria": "清除搜索",
      "filters": {
        "allProviders": "所有医生",
        "allTypes": "所有类型",
        "providerAriaLabel": "按医生筛选",
        "typeAriaLabel": "按预约类型筛选"
      },
      "columns": {
        "patient": "患者",
        "provider": "医生",
        "type": "类型",
        "priority": "优先级",
        "requestedDates": "申请日期",
        "dateAdded": "添加日期",
        "notes": "备注",
        "actions": "操作",
        "reason": "就诊原因"
      },
      "priority": {
        "urgent": "紧急",
        "routine": "常规",
        "flexible": "灵活"
      },
      "actions": {
        "scheduleTitle": "安排预约",
        "editPriorityTitle": "编辑优先级",
        "removeTitle": "从候补名单移除"
      },
      "empty": "没有符合筛选条件的候补记录",
      "loadFailed": "无法加载候补名单。请检查连接后重试。",
      "modal": {
        "title": "安排预约",
        "closeAria": "关闭",
        "providerLabel": "医生：",
        "requestedLabel": "申请：",
        "dateTimeLabel": "预约日期和时间 *",
        "dateAria": "预约日期",
        "timeAria": "预约时间",
        "requestedWindow": "申请窗口：{{start}} — {{end}}",
        "cancel": "取消",
        "submit": "安排"
      },
      "toasts": {
        "removed": "已从候补名单移除",
        "priorityUpdated": "优先级已更新",
        "scheduled": "已安排预约并从候补名单移除",
        "dateTimeRequired": "请选择日期和时间",
        "updateFailed": "更新候补名单失败",
        "promoteOrphaned": "预约已创建，但候补记录未能更新。重试前请先查看排班。"
      }
    },
    "checkIn": {
      "title": "患者登记",
      "subtitle": "登记 — 保险、授权和自付额。患者已到达。",
      "fields": {
        "insuranceId": "保险",
        "copayAmount": "自付额",
        "copayCollected": "已收取自付额",
        "authorizationNumber": "授权编号",
        "authorizationVerified": "授权已核实"
      },
      "copayHint": "标记已收取自付额将在患者账户中记录一笔付款。",
      "submit": "完成登记",
      "cancel": "取消",
      "toast": {
        "success": "患者已登记",
        "failed": "无法登记患者"
      }
    },
    "providerTypeahead": {
      "loadError": "医生名录不可用 — 请检查网络连接并重试。",
      "retry": "重试"
    }
  }
}
